/**
 * 柱状图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const barValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: ['string', 'date'], required: true },
    { field: 'y', type: 'number', array: true, required: true },
    { field: 'z', type: 'string', required: false }
  ],
  businessRules: [
    {
      name: 'bar-multi-y-z-conflict',
      validator: (data, layer) => {
        const { encoding } = layer;
        // 复用现有的 additionalBarChecks 逻辑
        return !(encoding?.z && Array.isArray(encoding?.y) && encoding.y.length > 1);
      },
      message: 'Multiple Y axes with Z dimension is not supported',
      suggestion: 'Use single Y field when Z dimension is present',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
